import { Box } from 'lucide-react';
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
  TooltipProvider,
} from '@/components/ui/tooltip';

interface WireframeToggleProps {
  wireframeOpacity: number;
  onOpacityChange: (value: number) => void;
}

export function WireframeToggle({
  wireframeOpacity,
  onOpacityChange,
}: WireframeToggleProps) {
  const isActive = wireframeOpacity > 0;

  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            onClick={() => onOpacityChange(isActive ? 0 : 1)}
            className={`flex h-7 w-7 items-center justify-center rounded transition-opacity hover:opacity-100 ${
              isActive ? 'opacity-100' : 'opacity-30'
            }`}
            aria-label="Toggle Wireframe"
          >
            <Box className="h-4 w-4 text-foreground" />
          </button>
        </TooltipTrigger>
        <TooltipContent
          side="top"
          className="flex items-center gap-2 border-border bg-background text-foreground"
        >
          <span>Wireframe</span>
          <kbd className="rounded border border-border bg-muted px-1 font-mono text-xs text-muted-foreground">
            W
          </kbd>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
